<template>
    <broadcast-card eyebrow="Πριν τον αγώνα" title="Προηγούμενες αναμετρήσεις">
        <div class="meetings">
            <div v-for="meeting in meetings" :key="meeting.id" class="meeting">
                <div class="meeting__date">{{ meeting.date }}</div>
                <div class="meeting__row">
                    <div class="meeting-team">
                        <span class="meeting-team__name" :class="{ 'meeting-team__name--lost': meeting.winner === 2 }">{{ meeting.team1.name }}</span>
                        <span class="meeting-team__logo"><img v-if="meeting.team1.logo" :src="meeting.team1.logo" alt=""></span>
                    </div>
                    <div class="meeting-score">
                        <span :class="{ 'meeting-score--won': meeting.winner === 1 }">{{ meeting.score1 }}</span>
                        <i>:</i>
                        <span :class="{ 'meeting-score--won': meeting.winner === 2 }">{{ meeting.score2 }}</span>
                    </div>
                    <div class="meeting-team meeting-team--right">
                        <span class="meeting-team__logo"><img v-if="meeting.team2.logo" :src="meeting.team2.logo" alt=""></span>
                        <span class="meeting-team__name" :class="{ 'meeting-team__name--lost': meeting.winner === 1 }">{{ meeting.team2.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </broadcast-card>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    import BroadcastCard from '@/components/BroadcastCard'

    const ASSETS_URL = 'https://storage.googleapis.com'

    // Pregame: how the two teams did against each other before (only shown when they have met)
    export default {
        name: 'PastMeetings',
        components: { BroadcastCard },
        props: {
            match: {
                type: Object,
                default: () => ({})
            },
            pastMatches: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            meetings() {
                const team = (item = {}) => ({ name: item.name, logo: item.logo ? `${ASSETS_URL}/${item.logo}` : null })
                return this.pastMatches.map((meeting) => {
                    const score1 = Number(meeting.scoreTeam1) || 0
                    const score2 = Number(meeting.scoreTeam2) || 0
                    return {
                        id: meeting.id,
                        date: meeting.matchDatetime
                            ? momentTimezone(meeting.matchDatetime).tz('Europe/Athens').locale('el').format('dddd D MMMM YYYY')
                            : '',
                        team1: team(meeting.team1),
                        team2: team(meeting.team2),
                        score1,
                        score2,
                        winner: score1 === score2 ? 0 : (score1 > score2 ? 1 : 2)
                    }
                })
            }
        }
    }
</script>

<style scoped>
.meetings {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.meeting {
    padding: 16px 24px 20px;
    border-radius: 16px;
    background: #2e2e2e;
}

.meeting__date {
    margin-bottom: 10px;
    color: rgba(255, 255, 255, 0.62);
    font-size: 1.05rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-align: center;
    text-transform: uppercase;
}

.meeting__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: 28px;
}

.meeting-team {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    min-width: 0;
}

.meeting-team--right {
    justify-content: flex-start;
}

.meeting-team__logo {
    overflow: hidden;
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 84px;
    height: 84px;
    padding: 6px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.16);
}

.meeting-team__logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.meeting-team__name {
    overflow: hidden;
    color: #fff;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0.02em;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.meeting-team__name--lost {
    color: rgba(255, 255, 255, 0.57);
}

/* same dark score box as the match header */
.meeting-score {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 22px;
    border-radius: 14px;
    background: #1b1b1b;
    color: rgba(255, 255, 255, 0.55);
    font-size: 3rem;
    font-weight: 800;
    line-height: 1;
    font-variant-numeric: tabular-nums;
}

.meeting-score i {
    font-style: normal;
    font-size: 2rem;
}

.meeting-score--won {
    background-image: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
